export const ENTITLEMENT_AUTO_CONVERT_LOAD = 'ENTITLEMENT_AUTO_CONVERT_LOAD'
export const ENTITLEMENT_AUTO_CONVERT_LOAD_PENDING = 'ENTITLEMENT_AUTO_CONVERT_LOAD_PENDING'
export const ENTITLEMENT_AUTO_CONVERT_LOAD_FULFILLED = 'ENTITLEMENT_AUTO_CONVERT_LOAD_FULFILLED'
export const ENTITLEMENT_AUTO_CONVERT_LOAD_REJECTED = 'ENTITLEMENT_AUTO_CONVERT_LOAD_REJECTED'

export const ENTITLEMENT_AUTO_CONVERT_UPDATE = 'ENTITLEMENT_AUTO_CONVERT_UPDATE'
export const ENTITLEMENT_AUTO_CONVERT_UPDATE_PENDING = 'ENTITLEMENT_AUTO_CONVERT_UPDATE_PENDING'
export const ENTITLEMENT_AUTO_CONVERT_UPDATE_FULFILLED = 'ENTITLEMENT_AUTO_CONVERT_UPDATE_FULFILLED'
export const ENTITLEMENT_AUTO_CONVERT_UPDATE_REJECTED = 'ENTITLEMENT_AUTO_CONVERT_UPDATE_REJECTED'
